module.exports = __webpack_public_path__ + "static/media/image (28).67adab9d.jpg";